export const agoraAppId = process.env["NEXT_PUBLIC_AGORA_APP_ID"];
